var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgStar01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_251_502)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.81 10.5375C20.2641 8.77211 22.3494 8.01313 23.8321 9.07365L30.6581 13.9562C31.1435 14.3034 31.7337 14.4726 32.3293 14.4354L40.7055 13.912C42.5248 13.7983 43.891 15.547 43.3406 17.2848L40.8064 25.2856C40.6262 25.8545 40.6476 26.4681 40.867 27.023L43.9532 34.8275C44.6235 36.5227 43.3826 38.3624 41.5598 38.3759L33.1675 38.4381C32.5707 38.4425 31.9938 38.6525 31.5338 39.0327L25.065 44.3796C23.6599 45.5409 21.5268 44.9293 20.9506 43.1998L18.2981 35.2375C18.1095 34.6713 17.7315 34.1875 17.2278 33.8675L10.1437 29.3675C8.60499 28.3901 8.52754 26.1724 9.99432 25.09L16.7473 20.1068C17.2274 19.7525 17.5708 19.2434 17.7194 18.6655L19.81 10.5375Z",
    fill: "#B3DB2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3414 6.96347C22.3761 4.84242 18.2056 6.36039 17.2974 9.89126L15.2068 18.0192L8.45384 23.0024C5.52027 25.1671 5.67518 29.6026 8.75259 31.5575L15.8367 36.0574L18.4892 44.0198C19.6415 47.4787 23.9077 48.702 26.7179 46.3793L33.1867 41.0325L41.579 40.9703C45.2247 40.9433 47.7065 37.2639 46.3658 33.8735L43.2797 26.069L45.8139 18.0682C46.9148 14.5926 44.1824 11.0953 40.5437 11.3226L32.1675 11.846L25.3414 6.96347Z",
    stroke: "white",
    strokeWidth: 5.18886,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_251_502",
    x: 0.998069,
    y: 0.641867,
    width: 51.0864,
    height: 52.2784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3767
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_251_502"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_251_502",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgStar01);
export default __webpack_public_path__ + "static/media/img_star_01.3e915751c9e9e9faac470110ef3cd5dc.svg";
export { ForwardRef as ReactComponent };